<template>
  <div class="ccui-app-iframe-no-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-no-operate-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini"
              >供应商澄清信息</el-button
            >
          </div>
        </div>
        <el-table
          :data="tableData"
          border
          @row-dblclick="viewDetails"
          class="dic-sub-table-style01"
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="supName"
            label="供应商"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
          <el-table-column
            property="noticeTitle"
            label="标题"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="viewDetails(row)">{{
                row.noticeTitle
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            property="updateTime"
            label="更新时间"
            show-overflow-tooltip
            width="180"
          ></el-table-column>
          <el-table-column
            property="noticeStatusStr"
            label="状态"
            show-overflow-tooltip
            width="120"
          ></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="{ row }">
              <el-button type="text" @click="viewDetails(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import { qrySupClearNoticeListApi } from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "supplierClarificationLetter",
  components: {
    breadcrumbSourcing
  },
  data() {
    return {
      breadcrumbData: {
        titname: "供应商澄清函"
      },
      tableData: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      qrySupClearNoticeListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        noticeStatuss: ["2", "3"]
      }).then(res => {
        res.data.data.forEach(item => {
          switch (item.noticeStatus) {
            case "0":
              item.noticeStatusStr = "编辑中";
              break;
            case "1":
              item.noticeStatusStr = "已发布";
              break;
            case "2":
              item.noticeStatusStr = "已澄清";
              break;
            case "3":
              item.noticeStatusStr = "未澄清";
              break;
            default:
              break;
          }
        });
        res.data.data.forEach(item => {
          item.updateTime = item.updateTime.substring(0, 16);
        });
        this.tableData = res.data.data;
      });
    },
    viewDetails(row, column, e) {
      this.$router.push({
        name: "addIssueClarificationNotice",
        query: {
          noticeId: row.noticeId,
          supName: row.supName,
          type: 2 // 0：发布澄清通知 1：查看澄清通知 2：查看澄清函内容
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
